import React, { useEffect, useState, useRef } from "react";
import { BsThreeDots } from "react-icons/bs";
import BusinessIcon from "@mui/icons-material/Business";
import SchoolIcon from "@mui/icons-material/School";
import ChatIcon from "@mui/icons-material/Chat";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import WorkIcon from "@mui/icons-material/Work";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  FaRegHeart,
  FaHeart,
  FaRegComment,
  FaRegShareSquare,
} from "react-icons/fa";
import { is } from "date-fns/locale";
import { set } from "date-fns";
const Profile = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [userEducation, setUserEducation] = useState([]);
  const [userExperience, setUserExperience] = useState([]);
  const [isConnected, setIsConnected] = useState('');
  const [requestsentbyme, setRequestsentbyme] = useState('');
  const [connectionId, setConnectionId] = useState(null); 
  const [userContact, setUserContact] = useState([]);
  const [userSkills, setUserSkills] = useState([]);
  const [showComments, setShowComments] = useState(false);
  const [postdata, setPostdata] = useState([]);
  const [post, setPost] = useState(null);

  const [likes, setLikes] = useState({});
  const [likedPosts, setLikedPosts] = useState({});

  const [commentLikes, setCommentLikes] = useState({});
  const [commentLikedPosts, setCommentLikedPosts] = useState({});
  useEffect(() => {
    getuserDetails();
    getPosts();
  }, []);

  const getPosts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `getposts/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const fetchedPosts = response.data.data;
      const comments = response.data.data.map((post) => post.comments);

      setPostdata(response.data.data);
      setPost(response.data.data[0]);

      const initialLikes = {};
      const initialLikedStatus = {};
      const initialcommentLikes = {};
      const initialcommentLikedStatus = {};
      const initialComments = {};

      fetchedPosts.forEach((post) => {
        initialLikes[post.id] = post.likes;
        initialLikedStatus[post.id] = post.has_liked;
        initialComments[post.id] = post.comments;
      });

      comments.forEach((comment) => {
        comment.forEach((comment) => {
          initialcommentLikes[comment.comment_id] = comment.comment_likes;
          initialcommentLikedStatus[comment.comment_id] =
            comment.has_liked_comment;
        });
      });
      setLikes(initialLikes);
      setLikedPosts(initialLikedStatus);
      setCommentLikes(initialcommentLikes);
      setCommentLikedPosts(initialcommentLikedStatus);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getuserDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `publicuser/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        setUserDetails(response.data.data.user_detail);
        setUserEducation(response.data.data.user_education);
        setUserExperience(response.data.data.user_experience);
        setUserContact(response.data.data.user_contact);
        setUserSkills(response.data.data.user_skill);
        setIsConnected(response.data.data.is_connected);
        setRequestsentbyme(response.data.data.request_sent_by_me);
        setConnectionId(response.data.data.connection_id);
        
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const AddConnectionRequest = async (id) => {
    console.log(id,"ohhh");
    const formData = new FormData();
    formData.append("request_to", id);
    try {
      const response = await axios.post(
        BaseUrl + `addtonetwork`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setIsConnected("pending");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } 
  };
  const Withdraw = async(id) => { 
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `rejectrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setIsConnected("");
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleAccept = async (id) => {
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `acceptrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setIsConnected("accepted");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-14">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4">
              <div className="relative">
                <img
                  src={userDetails?.bg_profile || "/Images/cover-img.jpg"}
                  alt="Creative design background"
                  className="w-full h-52 object-cover "
                />
                <div className="absolute bottom-0 left-4 transform translate-y-1/2">
                  <img
                    src={userDetails?.profile || "/Images/user-img.jpg"}
                    alt="Profile picture of Erikson George"
                    className="size-48 rounded-full border-4 border-white"
                  />
                </div>
              </div>
              <div className="pt-24 pb-6 px-6 text-start bg-white">
                <div className="flex mt-4 items-center justify-between">
                  <div>
                    <h1 className="text-2xl font-bold">{userDetails?.name}</h1>
                    <p className="text-black">{userDetails?.headline}</p>
                    <p className="text-gray-500 text-sm">
                      {userDetails?.city}, {userDetails?.country}.
                    </p>
                  </div>
                  <div className=" flex flex-col justify-between items-center">
                    {userExperience.length > 0 && (
                      <div className="flex items-center">
                        <BusinessIcon className="text-3xl text-gray-500 " />
                        <p className="ml-2 text-gray-600 text-sm w-56">
                          {userExperience ? userExperience[0]?.company : ""}
                        </p>
                      </div>
                    )}
                    {userEducation.length > 0 && (
                      <div className="flex items-center">
                        <SchoolIcon className="text-3xl text-gray-500 " />
                        <p className="ml-2 text-gray-600 text-sm w-56">
                          {userEducation ? userEducation[0]?.school : ""}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-4 flex flex-col sm:flex-row gap-3 text-sm justify-start">
                  {isConnected === "accepted" ? (
                    <button
                      className="text-white bg-blue-600 px-4 py-1 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-105"
                      onClick={() =>
                        navigate(`/user/messaging/${userDetails?.slug}`)
                      }
                    >
                      <ChatIcon className="mr-2" /> Message
                    </button>
                  ) : isConnected === "pending" ? (
                    requestsentbyme === 1 ? (
                      <button
                        className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-105"
                        onClick={() => Withdraw(connectionId)}
                      >
                        Withdraw
                      </button>
                    ) : (
                      <div className="flex gap-3">
                        <button
                          className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-105"
                          onClick={() => handleAccept(connectionId)}
                        >
                          Accept
                        </button>
                        
                      </div>
                    )
                  ) : (
                    <button
                      className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-105"
                      onClick={() => AddConnectionRequest(userDetails?.user_id)}
                    >
                      <PersonAddAltIcon className="mr-1 text-sm" /> Connect
                    </button>
                  )}
                </div>
              </div>

              {userDetails?.summary && (
                <div className="mt-4 bg-white rounded-lg shadow-lg p-4">
                  <h2 className="text-xl font-bold">About</h2>
                  <p className="text-gray-600 mt-2">{userDetails?.summary}</p>
                </div>
              )}

              <div className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                      Activity
                    </h2>
                    {/* <p className="text-blue-500 text-sm hover:underline cursor-pointer">
                      291 followers
                    </p> */}
                  </div>
                </div>

                {postdata.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                    {postdata?.slice(0, 2).map((post, index) => (
                      <div
                        key={index}
                        className="border border-gray-200 rounded-lg hover:shadow-md transition-shadow"
                        onClick={() => {
                          navigate("/user/editpost");
                        }}
                      >
                        <div className="flex items-start p-4">
                          <img
                            src={userDetails?.profile}
                            alt="Profile"
                            className="w-10 h-10 rounded-full mr-3 border border-gray-200"
                          />
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="font-semibold text-gray-900 hover:text-blue-600 cursor-pointer">
                                  {userDetails?.name}
                                </p>
                                <p className="text-gray-500 text-xs">
                                  {formatDate(post.created_at)}
                                  <span className="mx-1">•</span>
                                  <span>
                                    {post.type === "event" ? "Event" : "Post"}
                                  </span>
                                </p>
                              </div>
                              <button className="text-gray-500 hover:text-gray-700">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>

                        {post.type === "event" ? (
                          <div className="px-4 py-2">
                            <div className="w-full bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 ">
                              {post.media && (
                                <div className="">
                                  <img
                                    src={
                                      post.media.url || "/Images/cover-img.jpg "
                                    }
                                    alt="Event Preview"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              )}
                              <div className="flex justify-between p-4 bg-white">
                                <div className="w-[60%]">
                                  <p className="text-sm text-orange-600 font-semibold ">
                                    {post.event.time}
                                  </p>
                                  <h2 className="text-lg font-bold text-gray-900 mt-1">
                                    {post.event.event_name}
                                  </h2>
                                  <p className="text-sm text-gray-600">
                                    Event by {post.event.organizer}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    {post.event.event_type === "online"
                                      ? post.event.event_type
                                      : post.event.address}
                                  </p>
                                </div>
                                <Link
                                  to={`/events/${post.event.slug}`}
                                  className="flex items-center  h-8 px-4 text-blue-600 border border-blue-600 rounded-full hover:bg-blue-100"
                                >
                                  View event
                                </Link>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p className="text-[15px] px-4 pb-2 text-gray-800 leading-snug whitespace-pre-line">
                              {post.content}
                            </p>

                            <div
                              className={`grid gap-1 overflow-hidden ${
                                post.media.length === 1
                                  ? "grid-cols-1 min-h-[250px]"
                                  : "grid-cols-2 min-h-[250px]"
                              }`}
                            >
                              {post.media.slice(0, 4).map((image, index) => (
                                <div
                                  key={index}
                                  className={`relative group cursor-pointer flex justify-center ${
                                    post.media.length === 3 && index === 0
                                      ? "col-span-2"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setLightboxImages(post.media);
                                    // setSelectedImageIndex(index);
                                    setShowLightbox(true);
                                  }}
                                >
                                  <img
                                    src={image.url}
                                    alt={`preview-${index}`}
                                    className="h-full w-full object-cover"
                                  />
                                  {index === 3 && post.media.length > 4 && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                                      +{post.media.length - 4}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        <div className="mt-3 flex items-center text-xs text-gray-500 space-x-4 px-4 ">
                          <span>{post.likes} likes</span>
                          <span>{post.comments.length} comments</span>
                        </div>

                        <div className="mt-2 flex border-t border-gray-100 pt-2">
                          <button
                            onClick={() => handleLike(post.id)}
                            className={`flex-1 flex items-center justify-center py-1.5 space-x-1 rounded-md hover:bg-gray-100 text-sm ${
                              likedPosts[post.id]
                                ? "text-red-500"
                                : "text-gray-500"
                            }`}
                          >
                            {likedPosts[post.id] ? <FaHeart /> : <FaRegHeart />}
                            <span>Like</span>
                          </button>
                          <button
                            onClick={() => handleShowComments(index)}
                            className="flex-1 flex items-center justify-center py-1.5 space-x-1 text-gray-500 rounded-md hover:bg-gray-100 text-sm"
                          >
                            <FaRegComment />
                            <span>Comment</span>
                          </button>
                          <button className="flex-1 flex items-center justify-center py-1.5 space-x-1 text-gray-500 rounded-md hover:bg-gray-100 text-sm">
                            <FaRegShareSquare />
                            <span>Share</span>
                          </button>
                        </div>

                        {showComments[index] && (
                          <div className="mt-3 space-y-3">
                            <div className="flex space-x-2">
                              <img
                                src={introformData.profile_image}
                                alt="You"
                                className="w-8 h-8 rounded-full"
                              />
                              <div className="flex-1 relative">
                                <input
                                  type="text"
                                  className="w-full p-2 pl-3 pr-10 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                  placeholder="Add a comment..."
                                  value={newComments[post.id] || ""}
                                  onChange={(e) =>
                                    setNewComments((prev) => ({
                                      ...prev,
                                      [post.id]: e.target.value,
                                    }))
                                  }
                                />
                                <button
                                  onClick={(e) =>
                                    handleCommentSubmit(e, post.id)
                                  }
                                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>

                            <div className="space-y-2 max-h-[200px] overflow-y-auto pr-2">
                              {recievedcomments[post.id]
                                ?.slice(0, 3)
                                .map((comment) => (
                                  <div
                                    key={comment.comment_id}
                                    className="flex space-x-2"
                                  >
                                    <img
                                      src={
                                        comment.userAvatar ||
                                        "/default-avatar.png"
                                      }
                                      alt="User"
                                      className="w-7 h-7 rounded-full"
                                    />
                                    <div className="flex-1">
                                      <div className="bg-gray-50 p-2 rounded-lg">
                                        <div className="font-semibold text-xs">
                                          {comment.userName}
                                        </div>
                                        <p className="text-gray-800 text-xs mt-1">
                                          {comment.comment}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-4 text-left">
                    <p className="text-gray-700 font-semibold mb-1">
                      {userDetails?.name} hasn't posted yet
                    </p>
                    <p className="text-gray-500 text-sm mb-4">
                      Recent posts {userDetails?.name} shares will be displayed
                      here.
                    </p>
                  </div>
                )}

                {postdata?.length > 2 && (
                  <div className="border-t border-gray-200 p-4 text-center">
                    <a
                      href="/user/editpost"
                      className="text-gray-500 flex items-center justify-center hover:text-blue-500 group"
                    >
                      Show all activity{" "}
                      <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                    </a>
                  </div>
                )}
              </div>

              {userExperience.length > 0 && (
                <div className="mt-4 bg-white rounded-lg shadow-lg py-6">
                  <div className="flex justify-between items-center mb-4 px-4">
                    <h2 className="text-xl font-semibold">Experience</h2>
                  </div>
                  {userExperience.map((experience, index) => (
                    <div className="flex items-start space-x-4 px-8 border-b my-4 border-gray-200">
                      <WorkIcon
                        sx={{ fontSize: "40px" }}
                        className="text-gray-600 "
                      />
                      <div className="mb-4 ">
                        <h3 className="text-lg font-medium">
                          {experience.title}
                        </h3>
                        <p className="text-gray-600">{experience.company}</p>
                        {experience.start_month &&
                          experience.start_year &&
                          experience.end_month &&
                          experience.end_year &&
                          experience.length > 0 && (
                            <p className="text-gray-600">
                              {experience.start_month} {experience.start_year} -{" "}
                              {experience.end_month} {experience.end_year}
                            </p>
                          )}

                        {experience.length > 0 && (
                          <div className="flex items-center space-x-2 mt-2">
                            <i className="fas fa-gem text-gray-600"></i>
                            {experience.skills.map((skill, index) => (
                              <span className="text-gray-600">{skill}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {userEducation.length > 0 && (
                <div className="mt-4 bg-white rounded-lg shadow-lg py-4 px-4">
                  <div className="border-dashed border-2 border-blue-500 rounded-lg  py-6">
                    <div className="flex justify-between items-center px-6">
                      <h2 className="text-xl font-semibold">Education</h2>
                    </div>

                    {userEducation.map((education, index) => (
                      <div className="flex items-center mb-2 border-b px-6 py-2">
                        <i className="fas fa-school text-3xl text-gray-500 mr-4"></i>
                        <div>
                          <h3 className="text-lg font-semibold">
                            {education.school}
                          </h3>
                          <p className="text-gray-600">
                            {education.degree}, {education.field_of_study}
                          </p>
                          <p className="text-gray-600">
                            {education.start_year} - {education.end_year}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* <div className="mt-4 bg-white rounded-lg shadow-lg p-4">
                <h2 className="text-xl font-semibold mb-4">Interests</h2>
                <div className="flex items-center mb-4">
                  <a href="#" className="text-blue-500">
                    Companies
                  </a>
                </div>
                <hr className="my-4" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-start ">
                    <img
                      src="https://placehold.co/60x60"
                      alt="Company logo with abstract blue design"
                      className="w-12 h-12 rounded-none mr-4"
                    />
                    <div className="flex-1">
                      <h3 className="font-semibold">Logicspice Softwares</h3>
                      <p className="text-gray-600">10,258 followers</p>
                      <button className="border rounded-full px-4 py-1 mt-2 text-gray-600 flex items-center">
                        <i className="fas fa-check mr-2"></i>Tracking
                      </button>
                    </div>
                  </div>
                  <div className="flex items-start ">
                    <img
                      src="https://placehold.co/60x60"
                      alt="Company logo with abstract brown design"
                      className="w-12 h-12 rounded-none mr-4"
                    />
                    <div className="flex-1">
                      <h3 className="font-semibold">Logicspice Softwares</h3>
                      <p className="text-gray-600">10,258 followers</p>
                      <button className="border rounded-full px-4 py-1 mt-2 text-gray-600 flex items-center">
                        <i className="fas fa-check mr-2"></i>Tracking
                      </button>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div className="flex justify-center mt-4">
                  <button className="text-gray-600 flex items-center hover:text-blue-500 group">
                    Show all skills{" "}
                    <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                  </button>
                </div>
              </div> */}
            </div>
            <div className="w-full lg:w-1/4">
              <img
                src="https://placehold.co/200x200"
                alt="Profile picture"
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <div className="bg-white rounded-lg shadow-lg p-4 mt-4">
                <h2 className="text-lg font-semibold mb-4">
                  Other members also viewed
                </h2>
                <div className="space-y-4">
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Marie Clark"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Marie Clark</h3>
                        <p className="text-sm text-gray-600">
                          HR Manager at The Row
                        </p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 justify-self-start border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-envelope mr-1"></i>send a message
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Tom Karen</h3>
                        <p className="text-sm text-gray-600">Project Manager</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1 "></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Marie Clark"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Marie Clark</h3>
                        <p className="text-sm text-gray-600">UI/UX Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-envelope mr-1"></i>send a message
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Tom Karen</h3>
                        <p className="text-sm text-gray-600">Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1 "></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="mt-4 text-start ">
                    <button className="text-gray-600 text-sm">
                      Expand <i className="fas fa-chevron-down"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg p-4 mt-4">
                <h2 className="text-xl font-semibold mb-4">
                  People you may know
                </h2>
                <div className="space-y-4">
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Karl Mill"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Karl Mill</p>
                        <p className="text-sm text-gray-600">Web Artist</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>

                  <hr className="my-4" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Tom Karen</p>
                        <p className="text-sm text-gray-600">Web Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="my-4" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Mila Teren"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Mila Teren</p>
                        <p className="text-sm text-gray-600">Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div className="flex justify-center mt-4">
                  <button className="text-gray-600 text-sm flex items-center">
                    Expand <i className="fas fa-chevron-down ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;
